module.exports = __webpack_public_path__ + "static/media/camera.fc4a56fe.svg";